
///<reference path="../../App/plugins/DefinitelyTyped/bootstrap-select.d.ts"/>
///<reference path="../../App/plugins/DefinitelyTyped/bootstrap.multiselect.d.ts"/>
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
    templateUrl: './AppViews/ChangeRequest/ChangeRequest.html'
})

export class ChangeRequestComponent implements OnInit {

    constants: Constants;
    ChangeRequestDetails: any = [];
    isCommercialEdit: any = 0;
    userDetail: any;
    userDetailById: any
    showUsertab: boolean = false;
    addUpdateChangeRequest: any = {'Description' :"",'ProjectId':"",'ModuleId': "",'RequestedBy':"", 'RespondedBy':"",'StatusId': "", 'Comments': ""};
    addUpdateChangeFormActive: any = true;
    public showLoader = false;
    projects: any = [];
    IssueModuleList: any = [];
    severityItems: any = [];
    priorityItems: any = [];
    statusItems: any = [];
    catagoryItems: any = [];
    users: any = [];
    issueItems: any = [];
    public isaddUpdateChangeRequestFormSubmitted: boolean = false;
    public isFormSubmitted: boolean = false;
    projectItems: any = [];
    issueStatusItems: any = [];
    issueStageItems: any = [];
    issuePriorityItems: any = [];
    issueCatagoryItems: any = [];
    issueSeverityItems: any = [];
    issueAssigneeItems: any = [];
    issueReporterItems: any = [];
    updateIssue: any = {};
    reportedDate: number = 0;
    isEditableStatus: boolean = false;
    isEditableForAssignee: boolean = false;
    isEditableForStatus: boolean = false;
    isEditableForReporter: boolean = false;
    isEditableIssue: boolean = true;
    isEditable: boolean = true;
    fileList: any = [];
    remarkListItems: any = [];
    ChangeRequestLog: any =[];
    UserReportedBy:String;
    ip:string;
    ScreenshotPath:any;
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe, private route: ActivatedRoute, private _route: Router) {
        this.route
            .params
            .subscribe(
            data => {
                
                this.ChangeRequestDetails.ChangeRequestId = data["ChangeRequest"];
                this.isCommercialEdit = data["Com"];
                if(this.isCommercialEdit!=0){
                    this.isEditableForReporter = true;
                }
            }
            );
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        
        
      
       
        
    }
    ngOnInit() {
       this.geolocateUser();
       this.getuser();
       this.bindDropdownsData();
       if (this.ChangeRequestDetails.ChangeRequestId != 0) {
         this.getChangeRequest();
       }
     if (this.ChangeRequestDetails.ChangeRequestId == 0) {
      
         this.addUpdateChangeRequest = {'Description' :"",'ProjectId':"",'ModuleId': "",'RequestedBy':"", 'RespondedBy':this.userDetail.SiteUserId,'StatusId': 1, 'Comments': ""};
        // this.addUpdateChangeRequest.ReportedBy=this.userDetail.SiteUserId;
       //  this.UserReportedBy= this.userDetail.Name; 
         //  this.isEditable = false;
        //   this.isEditableIssue  = false;
         
     }


    }
    geolocateUser() {
        this.showLoader = true;
        this._httpService.ajaxGetIP().subscribe(
            data => {
                this.ip = data["ip"];
            },
            err => {
                this.ip = "Not Found.";
                this.showLoader = false;
              //  this.callGeoLocation();
            },
            () => {              
              //  this.callGeoLocation();
                this.showLoader = false;
            }
        );
    }

    bindDropdownsData() {
        this.showLoader = true;
        var TeamId = 0;

        this._httpService.ajaxPost("Project/GetAssignedProject", {  "ProjectId": 0, "OwnerTeamId": TeamId, "ProjectType": 0, "Status": 1, "UserId":  this.userDetail.SiteUserId,}).subscribe(
            data => {

                this.projectItems = data["ProjectList"];
                console.log("hgjgjh"+this.projectItems)
                    },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = true;
                this._httpService.ajaxPost('Common/GetParameter',
                    { "ParameterTypeId": this.constants.enumParamterTypeName["ServiceRequestStatusType"] }).subscribe(
                    data => {
                        this.statusItems = data["Parameter"];
                    },
                    err => {
                        this.showLoader = false;
                    },
                     () => {
                        this.showLoader = false;
                         }
 
                    ); this.showLoader = false;

                }); this.showLoader = false;
               
                if (this.ChangeRequestDetails.ChangeRequestId == 0)
               this.addUpdateChangeRequest.RespondedByName = this.userDetail.Name;
            }

    public getChangeRequest() {
        this.showLoader = true;
        if(this.isCommercialEdit!=0){
           
            this._httpService.ajaxPost("ChangeRequest/authoriseRequest", { "ChangeRequestId": this.ChangeRequestDetails.ChangeRequestId }).subscribe(
                data => {
                    // if(data["IssueItems"] != null)
                    this.GetChangeRequestById();
              
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },
    
                () => {
    
                  
                    this.showLoader = false;
                      }
    
                     );                        }
                   
                    else{
                        this.GetChangeRequestById();
                    }
     }



     public GetChangeRequestById(){
          
        this._httpService.ajaxPost("ChangeRequest/getChangeRequest", { "ChangeRequestId": this.ChangeRequestDetails.ChangeRequestId }).subscribe(
            data => {
                // if(data["IssueItems"] != null)
               
                this.addUpdateChangeRequest = data["ChangeRequest"][0];
                this.ChangeRequestLog =data["ChangeRequestLog"];
                this.addUpdateChangeRequest.Description = this.ChangeRequestLog.filter(element => element.CommentType == 4)[0].Comment;
                this.ChangeRequestLog =this.ChangeRequestLog.filter(element => element.CommentType != 4);
              //  this.ChangeRequestLog.filter(m1 => m1.CommentType == 1).forEach(c => c.CommentTypeName = "Emqube Comment");
                this.ChangeRequestLog.filter(m1 => m1.CommentType == "2").forEach(c => c.CommentTypeName = "Client Comment");
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {

                this.GetModule(this.addUpdateChangeRequest.ProjectId,null);
                this.showLoader = false;
                  }

                 );
     }
   
public CancelScreanShot() {
 
        $('#ViewScreanShot').modal('hide');
  
    }  

changeStatus(AssignedToId){


 
if((AssignedToId !="")&&( this.addUpdateChangeRequest.StatusId==1)){
    
    this.addUpdateChangeRequest.StatusId=2;
    this.showLoader = false;
    this.isEditableForStatus= false;
    this.issueStatusItems =this.issueStatusItems.filter(item => item.Value != 1);


}
else if((AssignedToId =="")&&(this.ChangeRequestDetails.ChangeRequestId == 0))
{
    
     this.addUpdateChangeRequest.StatusId=1;
      this.showLoader = false;

}

    this.showLoader = false;

}
    GetModule(ProjectId,from) {

              if(ProjectId!="" && ProjectId!=null )
              {

                
      this.showLoader = true;
          this._httpService.ajaxPost("ProjectModule/GetProjectModule",
            { "ProjectId": ProjectId }).subscribe(
            data => {
                if(from == 1) 
               { this.addUpdateChangeRequest.ModuleId="";
            }
                  if(data["ProjectModuleList"].length >0){
                this.IssueModuleList = data["ProjectModuleList"];
                  }
                  else{
                       let objItem: any = {};
                   
                    objItem.ProjectId = ProjectId;
                    objItem.ModuleName = "Main";;
                  //  objItem.ModuleId =0;
                   
             this._httpService.ajaxPost('ProjectModule/AddUpdateProjectModule',objItem).subscribe(
             data => {

                this.GetModule(ProjectId,null);
                 this.addUpdateChangeRequest.ModuleId="";
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
        );
                  }
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }

            );
           
        }
else{

    this.IssueModuleList={};
    this.addUpdateChangeRequest.ModuleId="";
}

    }

   
    DeleteIssueTab(form: any) {

         $('#deleteIssue').modal('hide');
        this.showLoader = true;
        
            this._httpService.ajaxPost('BugTracker/DeleteIssue', { "IssueId": this.addUpdateChangeRequest.IssueId }).subscribe(
                data => {
                    this._sharedService.ShowMessage(data["Status"].Message);
                    this._route.navigateByUrl("/bugTracker");
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },

                () => {
                    this.showLoader = false;
                }
            );

        
       
    }


    ReplyToRequest(addUpdateChangeRequest){

                                          }
            ReminderMail(addUpdateChangeRequest){
                this._httpService.ajaxPost('ChangeRequest/RemindRequest', this.addUpdateChangeRequest).subscribe(
                    data => {
    
                        var msg = data["Status"];
                       
                                this._sharedService.ShowMessage("success|Email send");
                          },
                    err => {
                        this.showLoader = false;
                       // this._route.navigateByUrl("/ChangeRequestList");
                        this._sharedService.ShowMessage(this.constants.globalError);
                    },
    
                    () => {
                        this.showLoader = false;
                    }
                );

            }
             CancelRequest(addUpdateChangeRequest){

             }
             CloseRequest(addUpdateChangeRequest){


             }


    AddUpdateChangeRequestTab(form: any) {

        if(this.validateCRDetails()){
        this.isaddUpdateChangeRequestFormSubmitted = true;
        this.addUpdateChangeRequest.userId = this.userDetail.SiteUserId;
      //p this.addUpdateChangeRequest.ReportedBy=this.userDetail.SiteUserId;
     //   if (form.form.valid) {
            if (this.ChangeRequestDetails.ChangeRequestId == 0) {

              this.showUsertab = true;
              this.addUpdateChangeRequest.CreatedDate=new Date();
              ///this.addUpdateChangeRequest.RespondedBy =this.userDetail.SiteUserId
              this.addUpdateChangeRequest.StatusChangedBy =this.userDetail.SiteUserId

            } 
            else {
                this.addUpdateChangeRequest.IssueId = this.ChangeRequestDetails.ChangeRequestId;
               
                this.showUsertab = true
            }
            
            this.showLoader = true;
            this.addUpdateChangeRequest.CommentType =1;
            if(this.addUpdateChangeRequest.StatusId==2 || this.addUpdateChangeRequest.StatusId==3)
            this.addUpdateChangeRequest.CommentType =3;
           
console.log("this.addUpdateChangeRequest:"+this.addUpdateChangeRequest);
            this._httpService.ajaxPost('ChangeRequest/addUpdateChangeRequest', this.addUpdateChangeRequest).subscribe(
                data => {

                    var msg = data["Status"].Message.split('|');
                   
                    if (msg.length >= 1) {

                        msg[0] = msg[0].toLowerCase();
                        if (msg[0] == "success") {
                            this._route.navigateByUrl("/ChangeRequestList");
                            this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
                        }
                        else if (msg[0] == "warning") {
                            this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
                        }
                        else {
                           // this._route.navigateByUrl("/ChangeRequestList");
                            this._sharedService.ShowMessage(this.constants.globalError);
                        }
                    }
                    else {
                    }
                },
                err => {
                    this.showLoader = false;
                   // this._route.navigateByUrl("/ChangeRequestList");
                    this._sharedService.ShowMessage(this.constants.globalError);
                },

                () => {
                    this.showLoader = false;
                }
            );
        // } else {

        //     this._sharedService.ShowMessage("warning|Mandatory Fields are Missing");
        // }
    }

    }

validateCRDetails(){
    var mandatory = "";
    var invalid = "";
    var functional = "";

    
    
            if(this.addUpdateChangeRequest.Description == "" || this.addUpdateChangeRequest.Description == null)
            {
                mandatory = mandatory + "<br> Description";
            }
            if(this.addUpdateChangeRequest.RequestedByEmail == "" || this.addUpdateChangeRequest.RequestedByEmail == null)
            {
                mandatory = mandatory + "<br>Requested By";
            }

            if(this.addUpdateChangeRequest.StatusId == "" || this.addUpdateChangeRequest.StatusId == null)
            {
                mandatory = mandatory + "<br>Status";
            }
          
      
            if(this.addUpdateChangeRequest.ProjectId == "" || this.addUpdateChangeRequest.ProjectId == null)
            {
                mandatory = mandatory + "<br>Project name";
            }

            if(this.addUpdateChangeRequest.ModuleId == "" || this.addUpdateChangeRequest.ModuleId == null)
            {
                mandatory = mandatory + "<br>Module name";
            }

          
    
    if (mandatory == "" && invalid == "" && functional == "") {
        return true;
    } else {
        var msg = "";
        if (mandatory != "") {
            msg = msg + "Please enter : " + mandatory;
            msg = msg + "<br>";
        }
        if (invalid != "") {
            msg = msg + "Please enter valid : " + invalid;
            msg = msg + "<br>";
        }
        if (functional != "") {
            msg = msg + functional;
        }
        this._sharedService.ShowMessage("error|" + msg);
  
    return false;

}

}
getuser(){
    this.showLoader = true;
    this._httpService.ajaxPost("Common/GetSiteUser").subscribe(
        data => {
           
            this.issueReporterItems = data["SiteUser"];

                // this.issueReporterItems = data["UserList"];
                     },
                       err => {
                       this.showLoader = false;
                              },
                    () => {
                     this.showLoader = false;
                       });
}

ChangeStatus(status){
    this.ip;
    if(status==4)
    this.addUpdateChangeRequest.StatusChangeComment="Authorized By: " +this.ip;
    if(status==3)
    this.addUpdateChangeRequest.StatusChangeComment="Cancelled By: " +this.ip;
    if(status==2)
    this.addUpdateChangeRequest.StatusChangeComment="completed By: " +this.ip;
    if(status==1)
    this.addUpdateChangeRequest.StatusChangeComment="requested By: " +this.ip;
   
        }
}



/** WEBPACK FOOTER **
 ** ./TypeScripts/ChangeRequest/ChangeRequest.component.ts
 **/